export function getIsActiveCssClasses(isActive) {
  let type = isActive ? "success" : "secondary";

  return `badge badge-soft-${
    type
  }`;
}